export function filterObject(obj = {}, callback = Function.prototype) {
  return Object.keys(obj).reduce(
    (acc, someKey) =>
      callback(someKey, obj, acc)
        ? {
            ...acc,
            [someKey]: obj[someKey],
          }
        : acc,
    {}
  )
}

export default filterObject
